import { MAX_SENDER_NAME_LENGTH, tlds } from '../constants';

function isValidDomain(domain) {
  const pattern = /^[a-zA-Z0-9]([a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?\.[a-zA-Z]{2,}$/;
  return !!pattern.test(domain);
}

const isEmailValid = value => {
  if (!isString(value)) return false;
  if (value?.length > 254) return false;

  const regex = new RegExp(
    '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])'
  );

  const endOfString = value?.split('.');
  const ending = endOfString.length - 1;
  const tld = endOfString[ending];

  if (tlds.indexOf(tld.toUpperCase()) < 0) {
    return false;
  }

  return regex.test(String(value).toLowerCase());
};

const isString = s => typeof s === 'string';

const isFloat = n => Number(n) === n && n % 1 !== 0;

const isEmptyField = value => {
  if (typeof value === 'boolean') {
    return false;
  }
  if (value === 0) {
    return 0;
  }

  return !value || (typeof value === 'number' && Number.isNaN(value)) || value?.length === 0;
};

const isNameValid = value => {
  if (!isString(value)) return false;

  const trimmed = value.trim();
  if (trimmed.length < 2 || trimmed.length > MAX_SENDER_NAME_LENGTH) return false;

  if (/[-'.]{2,}/.test(trimmed)) return false;
  if (/\s{2,}/.test(trimmed)) return false;

  const nameRegex =
    /^([a-zA-ZÀ-ÿ]([a-zA-ZÀ-ÿ'-]*[a-zA-ZÀ-ÿ])?\.?)(\s([a-zA-ZÀ-ÿ]([a-zA-ZÀ-ÿ'-]*[a-zA-ZÀ-ÿ])?\.?))*$/;

  return nameRegex.test(trimmed);
};

const isValidRule = async (rule, value) => {
  try {
    await rule.validate(value);
    return true;
  } catch (error) {
    return false;
  }
};

export { isEmailValid, isEmptyField, isFloat, isNameValid, isString, isValidDomain, isValidRule };
